import {
  hidePinForm,
  showPinForm,
} from 'containers/PinForm/actions/pinForm.actions';
import React, { useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTranslation } from 'utils/getTranslation';
import { editProfile } from '../redux/profile.actions';
import { hasPinConfigured } from 'containers/EPG/selectors/pin.selectors';
import { UserContext } from 'providers/user.provider';
import useHandleUserProvider from 'context/hooks/useHandleUserProvider';

export const useKidProfile = profileForm => {
  const dispatch = useDispatch();
  const translations = useSelector(state => state.translations);
  const statusPin = useSelector(hasPinConfigured);
  const { isAdmin } = useSelector(state => state.user);
  const {
    configProfileForm = {},
    profilesInfo = {},
  } = useSelector(state => state?.profilesManager ) || {};
  const user_image = configProfileForm?.user_image || ''
  const gamification_id = configProfileForm?.gamification_id || ''
  const members = profilesInfo?.members || []
  const [displayAlert, setDisplayAlert] = useState(false);
  const currentProfile = members?.find(
    member => member?.gamification_id === gamification_id,
  );
  const willChangeToKidProfile =
    profileForm?.is_kids && currentProfile?.is_kids !== 'true';
  const { changeProfile } = useContext(UserContext);
  const { handleChangeProfile } = useHandleUserProvider();

  const flowHasPinEditProfileToKids = () => {
    dispatch(
      showPinForm({
        type: 'UNBLOCK_CHANNEL',
        title: getTranslation(
          'lockPIN_access_subtitleKids_label',
          translations,
        ),
        onSuccess: async () => {
          await dispatch(
            editProfile({ ...profileForm, user_image, gamification_id }),
          );
          await dispatch(hidePinForm());
        },
      }),
    );
  };
  const flowAdminNotHasPinEditProfileToKid = () => {
    dispatch(
      showPinForm({
        type: 'DECIDE_NEW_PIN',
        title: getTranslation(
          'setupPin_confirmation_title_label',
          translations,
        ),
        onSuccess: async () => {
          await dispatch(
            editProfile({ ...profileForm, user_image, gamification_id }),
          );
          await dispatch(hidePinForm());
        },
      }),
    );
  };
  const flowsCheckToEditToKidProfile = () => {
    if (statusPin) return flowHasPinEditProfileToKids();
    if (isAdmin) return flowAdminNotHasPinEditProfileToKid();
    setDisplayAlert(true);
  };

  const handlerChangeProfile = (
    userHash,
    profilesInfo,
    adminUserId,
    target_gamification_id,
    current_gamification_id
  ) => {
    const actualProfile = profilesInfo?.members?.find(
      member => member?.gamification_id === current_gamification_id,
    )
    const targetProfile = profilesInfo?.members?.find(
      member => member?.gamification_id === target_gamification_id,
    );
    const isKidProfile = currentProfile?.is_kids === 'true' || actualProfile?.is_kids === 'true'  ;
    const targetProfileIsKid = targetProfile?.is_kids === 'true';
    const changeToKidProfile =
      (isKidProfile && !targetProfileIsKid) ||
      (!isKidProfile && targetProfileIsKid);
    if (changeToKidProfile)
      return changeProfile(userHash, profilesInfo?.members, adminUserId, true);
    handleChangeProfile(userHash, profilesInfo?.members, adminUserId, true);
  };

  return {
    flowsCheckToEditToKidProfile,
    willChangeToKidProfile,
    displayAlert,
    setDisplayAlert,
    currentProfile,
    handlerChangeProfile,
  };
};
